import React, { useCallback, useEffect, useState } from "react";
import { Button, Modal, Input } from "antd";
import GoogleAutocomplete from "react-google-autocomplete";

import {
  AddLocation,
  BASE_URL,
  GOOGLE_API_KEY,
  UPDATELocation,
} from "../../../utils/constant";
import LocationMapBlack from "../../../assets/icons/location-map-b.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Map from "../component/Map";

const LocationForm = ({ open, onCancel, initialValues }) => {
  const [locations, setLocations] = useState([]);
  const [locationName1, setLocationName] = useState("");
  const [shortLocationName, setShortLocationName] = useState("");
  const [coordinate, setCoordinate] = useState("");
  const [googleMapPosition, setGoogleMapPosition] = useState("");
  const [description, setDescription] = useState("");
  const [address, setAddress] = useState(initialValues?.address || "");
  const [mark, setMark] = useState({});
  const [modal2Open, setModal2Open] = useState(false);

  useEffect(() => {
    if (initialValues) {
      setLocationName(initialValues?.locationName1);
      setShortLocationName(initialValues?.locationName2);
      setDescription(initialValues?.description);
      setGoogleMapPosition(initialValues?.googleMapPosition);
      setAddress(initialValues?.address);
    } else {
      setLocationName("");
      setShortLocationName("");
      setDescription("");
      setGoogleMapPosition("");
      setAddress("");
    }
  }, [open]);
  const handleLocationName = useCallback((value) => {
    setLocationName(() => value.target.value);
  }, []);

  const handleDescription = useCallback((value) => {
    setDescription(() => value.target.value);
  }, []);

  const handleLocationShortName = useCallback((value) => {
    setShortLocationName(() => value.target.value);
  }, []);

  const handleGoogleMapPosition = useCallback((value) => {
    setGoogleMapPosition(() => value.target.value);
  }, []);
  const handlePlaceSelected = (place) => {
    const lat = place?.geometry?.location.lat();
    const lng = place?.geometry?.location.lng();
    setMark({ lat, lng });
    if (place && place.formatted_address) {
      setAddress(place.formatted_address);
      setGoogleMapPosition({ latitude: lat, longitude: lng });
    }
  };
  const getLocationandMarkFromMap = (location, address) => {
    setAddress(address);
    setGoogleMapPosition({ latitude: location.lat, longitude: location.lng });
    setMark(location);
  };
  const updateLocation = () => {
    const token = localStorage.getItem("authToken");
    const updateData = {
      locationId: initialValues.locationId,
      locationName1,
      isActive: initialValues.isActive,
      locationName2: shortLocationName,
      description,
      address,
      googleMapPosition,
    };
    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${UPDATELocation}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(updateData),
      });

      if (response.ok) {
        const data = await response.json();
        onCancel();
      } else {
        const data = await response.json();

        console.log("Location update failed:", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };

    fetchData();
  };
  const addLocation = async () => {
    if (!locationName1) {
      toast.error("Please fill Location Name.");
      return; // Prevent further execution if fields are not filled
    }
    if (!shortLocationName) {
      toast.error("Please fill Short Location Name.");
      return; // Prevent further execution if fields are not filled
    }

    if (!googleMapPosition) {
      toast.error("Please fill Google Map Position.");
      return; // Prevent further execution if fields are not filled
    }
    if (!address) {
      toast.error("Please fill Address.");
      return; // Prevent further execution if fields are not filled
    }
    if (initialValues) {
      await updateLocation();
      return;
    }

    const token = localStorage.getItem("authToken");
    const dataToSend = {
      locations: [
        {
          ...(locationName1 && { locationName1 }),
          ...(shortLocationName && { locationName2: shortLocationName }),
          ...(description && { description }),
          ...(googleMapPosition && { googleMapPosition }),
          ...(address && { address }),
        },
      ],
    };

    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${AddLocation}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(dataToSend),
      });

      if (response.ok) {
        const data = await response.json();
        onCancel();
      } else {
        const data = await response.json();
        console.log("location", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    if (dataToSend?.locations.length > 0) {
      fetchData();
    } else {
    }
  };
  const handleCancel = () => {
    onCancel();
  };
  const handleOk = async () => {};
  return (
    <Modal
      title="Add Location"
      open={open}
      className="HeadModalLocation"
      okButtonProps={{ style: { background: "grey" } }}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
    >
      <div className="">
        <div className="bg-[#EDF3FD] rounded-2xl px-4 py-4">
          <div>
            <label
              htmlFor="locationName"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              Location Name<span className="text-red-500">*</span>:
            </label>
            <Input
              className="h-10 bg-[#CDDEF9] mb-3 rounded-full !px-5 w-full placeholder:text-[13px] border-none"
              type="text"
              value={locationName1}
              onChange={handleLocationName}
            />
            <label
              htmlFor="locationName"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              Location Name (Short)<span className="text-red-500">*</span>{" "}
              (Maximum 5 letters are allowed):
            </label>
            <Input
              className="h-10 bg-[#CDDEF9] mb-3 rounded-full !px-5 w-full placeholder:text-[13px] border-none"
              type="text"
              maxLength={5}
              value={shortLocationName}
              onChange={handleLocationShortName}
            />
            <label
              htmlFor="Descripption"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              Description:
            </label>
            <textarea
              value={description}
              onChange={handleDescription}
              className="h-[60px] bg-[#CDDEF9] mb-2 rounded-xl !px-5 py-1 w-full placeholder:text-[13px] border-none outline-none resize-none"
            ></textarea>
            <label
              htmlFor="Google maps position"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              Google maps position<span className="text-red-500">*</span>:
            </label>
            <Input
              className="h-10 !bg-[#CDDEF9] mb-3 rounded-full !px-5 w-full placeholder:text-[13px] border-none"
              type="text"
              disabled={true}
              value={
                googleMapPosition
                  ? `${googleMapPosition.latitude}, ${googleMapPosition.longitude}`
                  : ""
              }
              onChange={handleGoogleMapPosition}
            />
            <label
              htmlFor="Google maps position"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              Address<span className="text-red-500">*</span>:
            </label>
            <div className="bg-[#CDDEF9] rounded-xl w-full  relative flex">
              <GoogleAutocomplete
                apiKey={GOOGLE_API_KEY}
                onPlaceSelected={handlePlaceSelected}
                options={{
                  types: ["geocode", "establishment"],
                  componentRestrictions: { country: "in" },
                }}
                filterReverseGeocodingByTypes={[
                  "locality",
                  "administrative_area_level_3",
                ]}
                placeholder="Enter address"
                className="w-full !px-5 py-3 h-[92px] pr-16 bg-transparent border-none outline-none"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />

              <img
                src={LocationMapBlack}
                onClick={() => setModal2Open(true)}
                className="absolute top-5 right-5 cursor-pointer"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="text-center mt-4">
        <Button
          className="!border-[#6198ED] bg-[#6198ED] text-[#ffffff] hover:bg-[#ffffff] hover:!text-[#6198ED] rounded-full py-2 px-5 h-auto !text-sm !outline-none"
          onClick={addLocation}
        >
          <span className="font-sbold">+Add Location</span>
        </Button>
      </div>
      <Modal
        title="Pin Your Location On Map"
        centered
        className="titleMarginleft"
        open={modal2Open}
        onOk={() => setModal2Open(false)}
        onCancel={() => setModal2Open(false)}
        footer={false}
      >
        <Map
          selectedLocation={{ address, mark }}
          getLocationandMarkFromMa={getLocationandMarkFromMap}
        />
      </Modal>
    </Modal>
  );
};

export default LocationForm;
